// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__T_VBx","paramInput":"JobSimulator_paramInput__KxAnl","input":"JobSimulator_input__2GZd1"};